export default {
  name: 'EmailTemplateParams',
  props: {
    messageCode: String
  },
  computed: {
    templateParameters () {
      const params = {};
      params.links = {
        title: this.$t('general.email.params.links'),
        items: [
          { code: 'FRONT_BASE', text: this.$t('general.email.param_values.front_base') },
          { code: 'HOME_URL', text: this.$t('general.email.param_values.home_url') }
        ]
      };
      params.user = {
        title: this.$t('general.email.params.user'),
        items: [
          { code: 'USER.NAME', text: this.$t('user.name') },
          { code: 'USER.EMAIL', text: this.$t('user.email') }
        ]
      };
      params.sender = {
        title: this.$t('general.email.params.sender'),
        items: [
          { code: 'SENDER.NAME', text: this.$t('user.name') },
          { code: 'SENDER.EMAIL', text: this.$t('user.email') },
          { code: 'SENDER.PHONES', text: this.$t('user.phones') }
        ]
      };
      if (this.messageCode === 'USER:PASSWORD_RESET') {
        params.links.items.push({ code: 'USER.PASS_RESET_URL', text: this.$t('general.email.param_values.pass_reset_url') })
      }
      if (this.messageCode === 'NOTIF:CONTRACT_ENDS') {
        params.notif = {
          title: this.$t('general.email.params.info'),
          items: [
            { code: 'NOTIF.CONTRACT_END_MINE', text: this.$t('general.email.param_values.info.contract_end_mine') },
            { code: 'NOTIF.CONTRACT_END_OTHER', text: this.$t('general.email.param_values.info.contract_end_other') },
            { code: 'NOTIF.CONTRACT_END_NONE', text: this.$t('general.email.param_values.info.contract_end_none') }
          ]
        }
      }
      return params;
    }
  }
}
